import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, DrawerBody, DrawerFooter } from '@chakra-ui/react';
import moment from 'moment-timezone';

import { TabNames } from '../../../../../../../../../../../constants/tabMenuTypes';
import { hideTray } from '../../../../../../../../../../../redux/modules/tray';
import { REQUIREMENT_TYPES } from '../../../../../../../../../util/options';
import { getCreateRequirementTemplateBlockParams } from '../../../../../../../../../util/util';

import CustomLanguageForm from './CustomLanguageForm';

function CreateCustomLanguageForm({ blueprint }) {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const currentRequirementTemplateBlocks = useSelector(blueprint.selectCurrentRequirementTemplateBlocks);
  const currentEditCustomLanguageId = useSelector(blueprint.selectCurrentEditCustomLanguageId);
  const activeStep = useSelector(blueprint.selectCreateCustomStep(TabNames.Language));
  const currentRequirementTemplateBlock = useSelector(blueprint.selectCurrentRequirementTemplateBlock);

  let currentMaxOrder = 0;

  useEffect(() => {
    if (currentRequirementTemplateBlocks) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      currentMaxOrder = Math.max(...[0,
        ...currentRequirementTemplateBlocks.map(templateBlock => templateBlock.order)]);
    }
  }, [currentRequirementTemplateBlocks, dispatch]);

  const createTemplateBlock = response => {
    if (response?.display_name?.length > 0) {
      dispatch(blueprint.createRequirementTemplateBlock(getCreateRequirementTemplateBlockParams(
        currentMaxOrder,
        REQUIREMENT_TYPES.Language,
        response
      )));
    }
  };

  const onSubmit = async data => {
    setSubmitting(true);
    const newCustomLanguageInfo = {
      name: data?.name,
      display_name: data?.languageName,
      language: data?.language ?? ''

    };

    if (data?.addToList === false || activeStep === 2) {
      newCustomLanguageInfo.deleted_at = moment().format('YYYY-MM-DD HH:mm:ss');
    }

    const response = (currentEditCustomLanguageId && activeStep !== 2)
      ? await dispatch(blueprint.updateInsuranceLanguage(currentEditCustomLanguageId, newCustomLanguageInfo))
      : await dispatch(blueprint.createInsuranceLanguage(newCustomLanguageInfo));

    if (response && !currentEditCustomLanguageId) {
      createTemplateBlock(response);
    }

    if (response && activeStep === 2) {
      await dispatch(blueprint.deleteRequirementTemplateBlock(currentRequirementTemplateBlock[0].id));
      createTemplateBlock(response);
    }

    setSubmitting(false);
    dispatch(blueprint.setCreateCustomStep(1, TabNames.Language));
    dispatch(blueprint.setEditCustomLanguageId(null));
    await dispatch(blueprint.listInsurancePolicyTypes());
    dispatch(hideTray());
  };

  return (
    <>
      <DrawerBody>
        <CustomLanguageForm blueprint={blueprint} formId="createCustomLanguageForm" onSubmit={onSubmit} />
      </DrawerBody>
      <DrawerFooter>
        <Button
          form="createCustomLanguageForm"
          isDisabled={submitting}
          type="submit"
          width="100%"
        >
          Save Language
        </Button>
      </DrawerFooter>
    </>
  );
}

export default CreateCustomLanguageForm;
